const Route = ({ path, element }) => {
  return { path, element };
};

export { Route };
